import React from "react";
import { Link } from "react-router-dom";
import ButtonSpinner from "../Loader/ButtonSpinner";
import { cn } from "../ui-x";
import { renderButtonIcon } from "./index";

type Props = {
  label?: string;
  href?: string;
  className?: string;
  onClick?: (e?: any) => void;
  type?: "button" | "submit" | "reset" | undefined;
  icon?: string;
  toBlank?: boolean;
  loading?: boolean;
};

const LinkButton = ({
  label,
  href,
  className,
  onClick,
  icon,
  toBlank,
  loading,
}: Props) => {
  const onClickHandler = (e: any) => {
    if (typeof onClick === "function") {
      e.preventDefault();
      onClick && onClick();
    }
  };

  return (
    <div>
      <Link
        to={`${href?.includes("http") ? "" : "/"}${href ? href : ""}`}
        target={toBlank ? "_blank" : ""}
        className={cn(
          "inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-lg px-4 text-sm font-semibold text-white transition-colors hover:cursor-pointer",
          className
        )}
        onClick={onClickHandler}
      >
        {label}
        {renderButtonIcon(icon)}
        {loading && <ButtonSpinner />}
      </Link>
    </div>
  );
};

export default LinkButton;
